const displayConditions = {
  formWithPreFilledData: {
    isURL: ["link", "sourceURLObj", "coverImageUrl"],
    isBoolean: [
      "isDefaultPlaylist",
      "isFeaturedPlaylist",
      "isDefaultService",
      "active",
      "addToNavMenu",
      "showSentEmail",
      "showPendingNote",
      "showModal",
      "showCover",
      "showLogo",
      "showLegal",
      "showDismissLink",
    ],
    isDate: ["releaseDate", "createdAt", "updatedAt"],
    richTextEditorNeeded: ["text", "textTwo", "textThree", "textFour"],
    protectedHidden: [
      "title",
      "slug",
      "identifier",
      "masterLibraryID",
      "_id",
      "iframeCustomAttributes",
      "defaultEmbedQuery",
    ],
    protectedVisible: [
      "PROTECT-ALL",
      "title",
      "releaseDate",
      "createdAt",
      "updatedAt",
      "slug",
      "identifier",
      "masterLibraryID",
    ],
  },
  emptyForm: {
    isURL: ["link", "sourceURLObj", "coverImageUrl"],
    isBoolean: [
      "isDefaultPlaylist",
      "isDefaultService",
      "isFeaturedPlaylist",
      "active",
      "addToNavMenu",
      "showSentEmail",
      "showPendingNote",
      "showModal",
      "showCover",
      "showLogo",
      "showLegal",
      "showDismissLink",
    ],
    isDate: ["releaseDate", "createdAt", "updatedAt"],
    richTextEditorNeeded: ["text", "textTwo", "textThree", "textFour"],
    protectedHidden: ["identifier"],
    protectedVisible: [],
  },
};

export default displayConditions;
